import { render, staticRenderFns } from "./dollar.vue?vue&type=template&id=927882ba&scoped=true&"
import script from "./dollar.vue?vue&type=script&lang=js&"
export * from "./dollar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927882ba",
  null
  
)

export default component.exports